

import { Box, CssBaseline, Grid, IconButton, ThemeProvider, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { MdPrint } from 'react-icons/md';
import brokerGroupApi from '../../../api/brokerGroupApi';
import customtheme from '../../../themes';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import logo from "../../../assets/logo-header.png";
import EnumMapper from '../../../EnumMapper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FlightCompensationApi from '../../../api/FlightCompensationApi';
import { TbBorderRight } from 'react-icons/tb';
import '../../../Styles/PrintStyle.css'
import { ContextNotification, severitys } from "../../../App";
// import PrintflightReportManifest from './PrintFlightReportManifest';

const FlightDelayCompensation = ({ flightId }) => {
    const customization = useSelector((state) => state.customization);
    const theme = useTheme();
    const rowStyle = {
        display: 'flex', justifyContent: 'flex-end', pb: 1, pt: 1, borderBottom: 'solid 1px rgb(28 117 101 / 41%)'
    };
    const [dataFlight, setDataFlight] = useState(null);
    const [dataFlightCost, setDataFlightCost] = useState(null);
    const { setOpen } = useContext(ContextNotification);
    const contentToPrint = useRef(null);
    const handlePrint = useReactToPrint({
        documentTitle: "چاپ اطلاعات تاخیر پرواز",
        onBeforePrint: () => {
            // document.body.classList.add("printing");
        },
        onAfterPrint: () => {
            // document.body.classList.remove("printing");
        },
        removeAfterPrint: true,
    });

    const GetFlightDelayForm = () => {
        FlightCompensationApi.GetFlightDelayFormByFlightId(flightId)
            .then((res) => {
                if(res.data?.success)
                {
                  setDataFlight(res.data.data);
                }
                else{
                setOpen({ IsEnable: true, Message: ' خطا در دریافت گزارش ', severity: severitys.error });
    
                }
                
            }
            )
            .catch(err => {
                console.log(err);
                setOpen({ IsEnable: true, Message: ' خطا در دریافت گزارش ', severity: severitys.error });
            });
    }

    useEffect(() => {
        GetFlightDelayForm();
    }, [])

    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                overflowX: 'auto',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                pt: 2,
                px: 2,
                pb: 2,
                height: '100%',
                overflow: 'scroll',
                border: 'solid 1px #000',

                "@media print": {
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 1
                }
            }}
        >

            <ThemeProvider theme={customtheme(customization)}>
                <div dir="rtl" >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: 'solid 1px #0000002d'
                    }}
                    >
                        <Box>
                            <Tooltip title="چاپ گزارش تاخیر پرواز" placement="top">
                                <IconButton style={{ margin: '2px', borderRadius: 0 }} onClick={() => {
                                    handlePrint(null, () => contentToPrint.current);
                                }}>
                                    <MdPrint color='#4a148c' />
                                </IconButton>
                            </Tooltip>


                        </Box>

                        <div ref={contentToPrint} >
                            <div dir='rtl' >

                                <TableContainer sx={{
                                    overflowX: "auto",
                                    "@media print": {
                                        overflowX: "visible"
                                    }
                                }} component={Paper}>
                                    <Table size="small" sx={{
                                        "@media print": {
                                            "& .MuiTableCell-root": {
                                                fontSize: "10px",
                                                padding: "2px 4px",

                                            }
                                        }
                                    }}  >
                                        <TableBody>
                                            <TableRow  >
                                                <TableCell width={'15%'}>
                                                    <Box sx={{
                                                        display: "flex",
                                                        width: 100,
                                                        height: 100,
                                                        gap: 1,
                                                        "@media print": {
                                                            width: 50,
                                                            height: 50,
                                                        }

                                                    }} >
                                                        <img id="loginlogoimage" src={logo} alt="موسسه عمره سعادت" />
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <Table>
                                                        <TableRow >
                                                            <TableCell align="center" >
                                                                {'فرم تاخیرات پروازی ' + dataFlight?.operationTitle}
                                                            </TableCell >
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                {dataFlight?.flightType === EnumMapper.FlightType.Departure ? 'اطلاعات پرواز  رفت ایران' : 'اطلاعات پرواز  برگشت از عربستان'}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow sx={{ backgroundColor: 'rgb(113, 185, 172)' }}>
                                                            <TableCell align="center">
                                                                {' شرکت هواپیمایی ' + dataFlight?.airLineTypeTitle}
                                                            </TableCell>
                                                        </TableRow>
                                                    </Table>

                                                </TableCell>

                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Table size="small" sx={{
                                        "@media print": {
                                            "& .MuiTableCell-root": {
                                                fontSize: "10px",
                                                padding: "2px 4px"
                                            }
                                        }
                                    }}  >

                                        <TableHead>
                                            <TableRow>
                                                <TableCell>تاریخ پرواز</TableCell>
                                                <TableCell>شماره پرواز</TableCell>
                                                <TableCell>ساعت پرواز طبق بلیط</TableCell>
                                                <TableCell>ساعت پرواز واقعی</TableCell>
                                                <TableCell>مدت تاخیر بر اساس ساعت و دقیقه</TableCell>
                                                <TableCell>فرودگاه مبدا</TableCell>
                                                <TableCell>فرودگاه مقصد</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>{dataFlight?.flightInfo?.percian_FlightDate}</TableCell>
                                                <TableCell>{dataFlight?.flightInfo?.flightNo}</TableCell>
                                                <TableCell>{dataFlight?.flightInfo?.flightTime}</TableCell>
                                                <TableCell>{dataFlight?.flightInfo?.flightTimeReal}</TableCell>
                                                <TableCell>{dataFlight?.flightInfo?.delayDurationInHoursAndMinutes}</TableCell>
                                                <TableCell>
                                                    {dataFlight?.originStationName ? dataFlight?.originStationName : ''}</TableCell>
                                                <TableCell>
                                                    {dataFlight?.destinationStationName ? dataFlight?.destinationStationName : ''}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>

                                    <Table size="small" sx={{
                                        "@media print": {
                                            "& .MuiTableCell-root": {
                                                fontSize: "10px",
                                                padding: "2px 4px"
                                            }
                                        }
                                    }} >
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align='center'  >
                                                    <Table align="center" border={1}  >
                                                        <TableHead style={{ background: '#77d6eeff', fontFamily: 'Vazir-Medium' }}>
                                                            <TableRow>
                                                                <TableCell >{'ردیف'}</TableCell>
                                                                <TableCell  >{'نام کاروان'}</TableCell>
                                                                <TableCell  >{'شماره کاروان'}</TableCell>
                                                                <TableCell  >{'کد گروه'}</TableCell>
                                                                <TableCell align="center" colSpan={5} rowSpan={2} >

                                                                    {'تعداد زائر'}

                                                                    <Table >
                                                                        <TableBody>
                                                                            <TableRow>
                                                                                <TableCell align="center"  >{'بالای 12 سال'}</TableCell>
                                                                                <TableCell align="center" >{'7-12 سال'}</TableCell>
                                                                                <TableCell align="center" >{'2-7 سال'}</TableCell>
                                                                                <TableCell align="center" >{'زیر 2 سال'}</TableCell>
                                                                                <TableCell align="center">{'جمع'}</TableCell>

                                                                            </TableRow>
                                                                        </TableBody>
                                                                    </Table></TableCell>
                                                                <TableCell >

                                                                    {'تعداد عوامل'}

                                                                </TableCell>
                                                            </TableRow>

                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                dataFlight?.flightInfo?.brokerGroupInfo?.sort((a, b) => a.groupNo >= b.groupNo ? 1 : -1).map((grp, index) => (
                                                                    <TableRow>
                                                                        <TableCell>{index + 1} </TableCell>
                                                                        <TableCell>{grp.name} </TableCell>
                                                                        <TableCell>{grp.code} </TableCell>
                                                                        <TableCell>{grp.groupNo} </TableCell>
                                                                        <TableCell>{grp.numberOfPilgrimByAgeGroup?.numberOfAdult} </TableCell>
                                                                        <TableCell>{grp.numberOfPilgrimByAgeGroup?.numberOfYoung} </TableCell>
                                                                        <TableCell>{grp.numberOfPilgrimByAgeGroup?.numberOfMinor} </TableCell>
                                                                        <TableCell>{grp.numberOfPilgrimByAgeGroup?.numberOfChild} </TableCell>
                                                                        <TableCell>{grp.numberOfPilgrim} </TableCell>
                                                                        <TableCell>{grp.numberOfAgent} </TableCell>
                                                                    </TableRow>
                                                                )
                                                                )
                                                            }
                                                            {
                                                                <TableRow>
                                                                    <TableCell align="center" colSpan={4}>{'جمع کل نفرات:'}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalAdult}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalYoung}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalMinor}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalChild}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalPilgrim}</TableCell>
                                                                    <TableCell>{dataFlight?.flightInfo?.numberOfTotalAgent}</TableCell>
                                                                </TableRow>
                                                            }

                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                                <TableCell align="center" sx={{ verticalAlign: "top" }}  >
                                                    <Box sx={{ border: 1, background: '#77d6eeff' }}>

                                                        {'خدمات اسکان'}

                                                    </Box>
                                                    <Table align="center" border={1}   >
                                                        <TableHead style={{ background: '#77d6eeff' }} >
                                                            <TableRow>
                                                                <TableCell align="center" >{'نام هتل'}</TableCell>
                                                                <TableCell align="center">{'تعداد اتاق'}</TableCell>
                                                                <TableCell align="center" >{'مدت اقامت'}</TableCell>
                                                                <TableCell align="center" >{'نرخ'}</TableCell>
                                                                <TableCell align="center" >{'مبلغ'}</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                dataFlight?.flightInfo?.flightCompensationForGroupAccommodation?.map((itm, index) => (
                                                                    <TableRow>
                                                                        <TableCell align="center" w>{itm.hotelName} </TableCell>
                                                                        <TableCell align="center" >{itm.numberOfRooms} </TableCell>
                                                                        <TableCell align="center" >{itm.lengthOfStay} </TableCell>
                                                                        <TableCell align="center" >{itm.roomRate} </TableCell>
                                                                        <TableCell align="center" >{itm.amount} </TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                            <TableRow>
                                                                <TableCell align="center" colSpan={4}>{'جمع مبلغ:'}</TableCell>
                                                                <TableCell align="center">{dataFlight?.flightInfo?.totalAmountOfAccommodation}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                                <TableCell align="center" border={1} sx={{ verticalAlign: "top" }}  >
                                                    <Box sx={{ border: 1, background: '#77d6eeff' }}>

                                                        {'خدمات تغذیه'}

                                                    </Box>
                                                    <Table align="center" border={1} cellSpacing={0} cellPadding={10} style={{ fontSize: '14px', fontFamily: 'Vazir-Medium' }} >
                                                        <TableHead style={{ background: '#77d6eeff', fontFamily: 'Vazir-Medium' }}>
                                                            <TableRow>
                                                                <TableCell align="center" >{'نام وعده غذایی'}</TableCell>
                                                                <TableCell align="center" >{'نرخ'}</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                dataFlight?.flightInfo?.flightCompensationForGroupNutrition?.map((itm, index) => (
                                                                    <TableRow>
                                                                        <TableCell align="center" >{itm.mealTypeTitle} </TableCell>
                                                                        <TableCell align="center" >{itm.mealRate} </TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                            <TableRow>
                                                                <TableCell align="center" >{'جمع مبلغ:'}</TableCell>
                                                                <TableCell align="center">{dataFlight?.flightInfo?.totalAmountOfNutrition}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                                <TableCell align="center" border={1} sx={{ verticalAlign: "top" }}  >
                                                    <Box sx={{ border: 1, background: '#77d6eeff' }}>

                                                        {'نقل'}

                                                    </Box>
                                                    <Table align="center" border={1}   >
                                                        <TableHead style={{ background: '#77d6eeff', fontFamily: 'Vazir-Medium' }}>
                                                            <TableRow>
                                                                <TableCell align="center" >{'نام وسیله نقلیه'}</TableCell>
                                                                <TableCell align="center" >{'تعداد مسافر'}</TableCell>
                                                                <TableCell align="center" >{'نرخ'}</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataFlight?.flightInfo?.flightCompensationForGroupTransfer?.map((itm, index) => (
                                                                <TableRow>
                                                                    <TableCell align="center" >{itm.vehicleTypeTitle} </TableCell>
                                                                    <TableCell align="center" >{itm.passengerCount} </TableCell>
                                                                    <TableCell align="center" >{itm.transferRate} </TableCell>
                                                                </TableRow>
                                                            ))
                                                            }
                                                            <TableRow>
                                                                <TableCell align="center" colSpan={2} >{'جمع مبلغ:'}</TableCell>
                                                                <TableCell align="center">{dataFlight?.flightInfo?.totalAmountOfTransfer}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>


                                            </TableRow>


                                        </TableBody>
                                    </Table>
                                    <Table sx={{

                                        "@media print": {
                                            "& .MuiTableCell-root": {
                                                fontSize: "10px",
                                                padding: "2px 4px"
                                            }
                                        }
                                    }}>
                                        <TableRow>
                                            <TableCell align="center" height={100}  >{'امضای نماینده فرودگاه'}</TableCell>
                                            <TableCell align="center" height={100} >{'امضای نماینده موسسه'}</TableCell>
                                            <TableCell align="center" height={100} >{'امضای نماینده ' + dataFlight?.airLineTypeTitle}</TableCell>

                                        </TableRow>
                                    </Table>
                                </TableContainer>


                            </div>
                        </div>
                    </Box>
                </div>

            </ThemeProvider>
        </Box>

    )
}

export default FlightDelayCompensation